// 每个页面通用方法
import thsJsBridge from '@fs/jsbridge/dist/lib/thsJsBridge.js'
import { getRunEnv } from '@/utils/env.js'
import { isTHSI18NApp, isInOutsideH5 } from '@fs/utils'
import Vue from 'vue'
import { thsI18NJsBridge } from '@fs/jsbridge'
import '@/utils/registerSentry.js'

thsJsBridge()

import '@/globalProterties/index.js'
// 神策埋点
import initSensors, { initThsI18nWebLog } from '@/utils/bury.js'

try {
    initSensors()
} catch (err) {
    console.warn(err)
    //神策包错误不用上送
}

if (getRunEnv() === 2) {
    sessionStorage.setItem('runEnv', '2') // 同花顺环境标识,首次进来必有wtToken, 后续依赖于session存储判断
}
// 同花顺国际版初始化
export const initThsI18nJsBridge = () => {
    if (isTHSI18NApp()) {
        Vue.prototype.$thsI18NJsBridge = thsI18NJsBridge
    }
}
export const initThsI18nBury = () =>
    new Promise(resolve => {
        Vue.prototype.$thsI18nTrack = () => {}
        if (isTHSI18NApp()) {
            thsI18NJsBridge.getHostUserInfo?.(
                data => {
                    Vue.prototype.$thsI18nTrack = initThsI18nWebLog(data.userId)
                    resolve()
                },
                () => {
                    resolve()
                }
            )
        } else {
            resolve()
        }
    })

initThsI18nJsBridge()

if (isInOutsideH5()) {
    document.body.classList.add('in-outside-h5')
}
